import { render, staticRenderFns } from "./UserDisplay.vue?vue&type=template&id=3d075771&scoped=true"
import script from "./UserDisplay.vue?vue&type=script&lang=js"
export * from "./UserDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d075771",
  null
  
)

export default component.exports